import { z } from './zod';
/**
 * Bidirectional Zod transforms for backend epoch-seconds dates.
 *
 * The backend uses `number` (seconds since epoch); the entity sees `Date`.
 * We define both directions as schemas so the same source of truth handles
 * deserialize and serialize.
 */
/** API -> entity (epoch seconds -> Date) */
export const epochSecondsToDate = z.number().transform((seconds) => new Date(seconds * 1000));
export const epochSecondsToDateNullable = z
    .number()
    .nullable()
    .transform((seconds) => (seconds == null ? null : new Date(seconds * 1000)));
export const epochSecondsToDateOptional = z
    .number()
    .optional()
    .transform((seconds) => (seconds == null ? undefined : new Date(seconds * 1000)));
/** Entity -> API (Date -> epoch seconds) */
export const dateToEpochSeconds = z.date().transform((date) => Math.floor(date.getTime() / 1000));
export const dateToEpochSecondsNullable = z
    .date()
    .nullable()
    .transform((date) => (date == null ? null : Math.floor(date.getTime() / 1000)));
export const dateToEpochSecondsOptional = z
    .date()
    .optional()
    .transform((date) => (date == null ? undefined : Math.floor(date.getTime() / 1000)));
//# sourceMappingURL=date.js.map